import { ThemeProvider } from '@mui/material';
import { Outlet, useLocation } from 'react-router-dom';
import { sendPost } from './api/common';
import ChannelIO from './components/common/ChannelIO';
import Footer from './components/footer/Footer';
import RouteHeader from './components/header/RouteHeader';
import { EpicProvider } from './context/EpicContext';
import { useTheme } from './hooks/useTheme';
import SubsidiarySetter from './pages/common/SubsidiarySetter';

interface configDict {
	status: unknown;
	headers: any;
	data: any;
}

export async function initSysCompanyConfigs() {
	const res = await sendPost<configDict>('/get_sysconfig_list_by_company/');
	return res;
}

export default function App() {
	const theme = useTheme();
	const location = useLocation();

	const isTestSealPage =
		location.pathname === '/sign/test-contract-seal' || location.pathname.includes('/sign/modify-contract-seal');

	if (isTestSealPage) {
		return (
			<ThemeProvider theme={theme}>
				<Outlet />
			</ThemeProvider>
		);
	}

	return (
		<ThemeProvider theme={theme}>
			<section className='flex flex-col min-h-screen' style={{ backgroundColor: theme.palette.body.main }}>
				<SubsidiarySetter>
					<RouteHeader />
					<main className='flex-1 w-full'>
						<EpicProvider>
							<Outlet />
							<ChannelIO />
						</EpicProvider>
					</main>
				</SubsidiarySetter>
				<Footer />
			</section>
		</ThemeProvider>
	);
}
